module.exports = "images/reglage.8f408db0.png";